import useCasesEn from './use-cases.en'
import useCasesCn from './use-cases.cn'

export const useCases = {
  en: useCasesEn,
  cn: useCasesCn,
}

export default useCases[process.env.GATSBY_LOCALE] || useCases['en']
